import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'
import * as Yup from 'yup'

import { MyFormValues } from 'partials/EditProfileForm'

import { Box } from 'widgets/Box'
import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'
import { Text } from 'widgets/Text'

type FirstAndLastNameFormProps = {
  initialValues: MyFormValues
  onSubmit: (values: any) => void
}

export const FirstAndLastNameForm = ({ initialValues, onSubmit }: FirstAndLastNameFormProps) => {
  const theme = useTheme()
  const computedStyles = StyleSheet.create({
    fieldStyles: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: theme.colors.greyLight,
      color: 'white',
    },
  })

  return (
    <>
      <Box testID='FormTitleContainer' margin={{ horizontal: 'md' }}>
        <Text color='white'>What&apos;s your name?</Text>
      </Box>
      <Box testID='FirstAndLastNameForm' margin={{ top: 'sm' }}>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          submitCopy='NEXT'
          validationSchema={Yup.object().shape({
            firstName: Yup.string().required('This field is required.'),
            lastName: Yup.string().required('This field is required.'),
          })}
        >
          {({ errors: formikErrors, touched }: any) => {
            return (
              <>
                <Field
                  required
                  name='firstName'
                  placeholder='First name'
                  placeholderTextColor={theme.colors.greyDarker}
                  style={computedStyles.fieldStyles}
                />
                <Field
                  required
                  name='lastName'
                  placeholder='Last name'
                  placeholderTextColor={theme.colors.greyDarker}
                  style={computedStyles.fieldStyles}
                />
              </>
            )
          }}
        </Form>
      </Box>
    </>
  )
}
